import React from 'react';
import Lottie from 'lottie-react';
import "./Header_lottie_btn_animation.css";

function Header_lottie_btn_animation({animationData}) {
  return (
    <section className='Header_lottie_btn_animation'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="arrow_lottie"
      />
    </section>
  );
}

export default Header_lottie_btn_animation;
